import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    player: {
        playerList: [],
        pending: false
    },
    total: 0,
    loading: false,
    searching: false,
    searchParams: {
        clubNo: "",
        userID: "",
        roomNo: "",
        roomID: "",
        settleID: "",
        matchNo: "",
        roomType: "3",
        status: "4",
        is_senior: "",
        has_result: "",
        gameIDs: "-1",
        start_date: undefined,
        end_date: undefined,
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("roomClub")
    },
}

const roomClub = (state = initialState, action) => {
    switch (action.type) {
        case 'ROOM_CLUB_LIST':
            return {
                ...state,
                ...action.payload
            }
        case 'ROOM_CLUB_PLAYER_LIST':
            return {
                ...state,
                player: {
                    ...state.player,
                    ...action.payload
                }
            }
        case 'ROOM_CLUB_LIST_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("roomClub")
                },
            }
        default:
            return {...state};
    }
}

export default roomClub
